import React from "react";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import "dayjs/locale/tr";
import dayjs from "dayjs";

const CustomDatePicker = ({ id, label, value, handleChange }) => {
  return (
    <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale="tr">
      <DatePicker
        label={label}
        name={id}
        value={value ? dayjs(value) : null}
        onChange={(newValue) => {
          handleChange({ name: id, value: newValue });
        }}
      />
    </LocalizationProvider>
  );
};

export default CustomDatePicker;
